import React from 'react'
import app from '../../ui/app'
import PropTypes from 'prop-types'
import { logger } from '../../ui/lib/logging'

/**
 * @param {string} pageId
 * @param {string[]} params
 * @returns {*}
 */
const logNavigation = (pageId, params) => logger.info(
  `%cNavigate to: %c${pageId} %c[${params}]`,
  'font-weight: bold',
  'color: blue;',
  'color: green'
)

/**
 * @param {React.ReactNode} children
 * @param {string} href
 * @param {*} rest
 * @returns {JSX.Element}
 */
const Link = ({ children, href, ...rest }) => {
  const [pageId, ...params] = href.replace(/^\//, '').split('/')

  const handleClick = (event) => {
    event.preventDefault()
    logNavigation(pageId, params)
    app.changePage(pageId, ...params)
  }

  return (
    <a onClick={handleClick} href={`${href}`} {...rest}>
      {children}
    </a>
  )
}

Link.defaultProps = {
  href: ''
}

Link.propTypes = {
  href: PropTypes.string
}

export { Link }
